import { mostraAlertaError, mostraAlertaOk, mostraAlertaPregunta } from "../../../../componentes/alerts/sweetAlert";
import { useEffect, useState } from "react";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ProveedoresEliminar, ProveedoresListar } from "../../../../configuracion/apiUrls";

const EliminarProveedor = ({ datos, token, setListaProveedores, ActualizarLista }) => {
    const [eliminar, setEliminar] = useState(false);

    useEffect(() => {
        if (eliminar)
            eliminarProveedor();
    }, [eliminar]);

    const eliminarProveedorPregunta = async () => {
        mostraAlertaPregunta(setEliminar, `¿Deseas eliminar el proveedor ${datos.nombre} de forma permanente?`, "warning");
    };

    const eliminarProveedor = async () => {
        if (!datos.id)
            mostraAlertaError("Seleccione un proveedor");
        else {
            try {
                AxiosPrivado.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                AxiosPrivado.delete(ProveedoresEliminar + datos.id)
                    .then((respuesta) => {
                        ActualizarLista(ProveedoresListar, setListaProveedores);
                        mostraAlertaOk("Registro eliminado correctamente");
                    }).catch((er) => {
                        console.log(er);
                        let msjError = "";
                        switch (er.response.status) {
                            case 400:
                                if (er.response.data && Array.isArray(er.response.data)) {
                                    er.response.data.map(f => {
                                        msjError += f.msg + '. ';
                                    });
                                }
                                break;
                            case 404:
                                msjError = er.response.data.error;
                                break;
                            case 500:
                                msjError = er.response.data.error;
                                break;
                            default:
                                msjError = "Ocurrió un error desconocido.";
                                break;
                        }
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
        setEliminar(false);
    };

    return (
        <button type="button" className="btn btn-outline-danger" onClick={eliminarProveedorPregunta}>
            <i className="fas fa-trash" />
        </button>
    );
};

export default EliminarProveedor;